import { CommonModule } from "@angular/common";
import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SPINNER_DIRECTIVES } from "@igo2/common/spinner";
import { STOP_PROPAGATION_DIRECTIVES } from "@igo2/common/stop-propagation";
import { ConfigService } from "@igo2/core/config";
import { MessageService } from "@igo2/core/message";
import Bowser from "bowser";
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, debounceTime, take } from "rxjs";
import { FicheCommentaireComponent } from "src/app/integration/sigt-rapport-commentaire/fiche-commentaire/fiche-commentaire.component";
import { GdfImpressionBailComponent } from "src/app/integration/sigt-recherche-gdf/gdf-impression-bail/gdf-impression-bail.component";
import { FicheDescriptiveComponent } from "src/app/pages/fiche-descriptive/fiche-descriptive.component";
import { PortalComponent } from "src/app/pages/portal/portal.component";
import { ViewportService } from "src/app/shared/services/viewport.service";

@Component({
    templateUrl: './carte.component.html',
    imports: [
        CommonModule,
        SPINNER_DIRECTIVES,
        STOP_PROPAGATION_DIRECTIVES,
        PortalComponent,
        FicheDescriptiveComponent,
        FicheCommentaireComponent,
        GdfImpressionBailComponent,
    ]
})

export class CarteComponent implements OnInit {
  #configService = inject(ConfigService);
  #messageService = inject(MessageService);
  #viewportService = inject(ViewportService);
  #route = inject(ActivatedRoute);

  hasHeader = this.#configService.getConfig('header.hasHeader', false);
  hasFooter = this.#configService.getConfig('hasFooter', false);

  standaloneMode = new BehaviorSubject<string>(undefined);

  ngOnInit(): void {
    this.#viewportService.setCarteViewport();
    this.#detectOldBrowser();

    this.#route.queryParams
      .pipe(
        debounceTime(500),
        take(1)
      )
      .subscribe(params => {
        this.standaloneMode.next(params['sa'] ?? '');
      });
  }

  #detectOldBrowser() {
    const oldBrowser = Bowser.getParser(window.navigator.userAgent).satisfies({
      ie: '<=11',
      chrome: '<64',
      firefox: '<60',
      safari: '<=11'
    });

    if (oldBrowser) {
      this.#messageService.alert('oldBrowser.message', 'oldBrowser.title', {
        timeOut: 15000
      });
    }
  }
}
